<template>
  <modal-wrapper
    ref="modalRef"
    :display-cancel-button="false"
    :show-header="false"
  >
    <div class="mb-2">
      <strong>{{ t('uploadUpdateView.errors.unknownFiles') }}</strong>
    </div>
    <ul>
      <li
        v-for="record in props.invalidUploadRecords"
        :key="record.file?.name"
        class="list-disc ml-2"
      >
        {{ record.file?.name }}
      </li>
    </ul>
  </modal-wrapper>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n';
  import { IUploadRecord } from '../MassUpload/MassUpload.types';
  import { useModalWrapper } from '../ModalWrapper';

  const { t } = useI18n();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });

  const props = defineProps<{ invalidUploadRecords: IUploadRecord[] }>();
</script>
